import React, { createContext, useContext } from "react";
import { FlareContextType } from "./types";
import { ERROR_MESSAGES } from "./constants";

export const FlareContext = createContext<FlareContextType | undefined>(
  undefined,
);

/**
 * Custom hook to access the Flare context
 * @throws {Error} If used outside of FlareContextProvider
 * @returns {FlareContextType} The Flare context value
 */
export const useFlareContext = (): FlareContextType => {
  const context = useContext(FlareContext);
  if (!context) {
    throw new Error(ERROR_MESSAGES.CONTEXT_NOT_FOUND);
  }
  return context;
};
